import { Modal } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
    .ant-modal-content > .ant-modal-body {
        .modal__session-inactive-row {
            .modal-icon-col { 
                .anticon {
                    font-size: 3.5rem;
                }

                margin-bottom: 16px;
            }
            
            .modal-text-col {
                flex-direction: column;
                margin-bottom: 16px;
                text-align: center;

                h2 {    
                  padding-bottom: 8px;
                  line-height: 1.2;
                }
            }
            

            .modal-form-col {
                .ant-form {
                    max-width: 230px;
                }

                .ant-form-item {
                    margin-bottom: 0;

                    &:first-child {
                        .ant-input-affix-wrapper {
                            border-radius: 6px 6px 0 0;
                        }
                    }
    
                    &:not(:first-child, :last-child) {
                        .ant-input-affix-wrapper {
                            border-radius: 6px;
                        }
                    }
    
                    &:not(:first-child) {
                        margin-top: -1px;

                        .ant-input-affix-wrapper {
                            border-radius: 0 0 6px 6px;
                        }
                    }
                }
            }
        }
    }
`;
